import React from "react";

import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import {
    FieldsContainerBox,
    FullGridLineBox,
    SectionTitleBox
} from "../common/boxes/pso-agreement.boxes";
import {
    DateFieldEditorWithInputMaskComponent,
    DateFieldMask
} from "../../../forms/date-time/date-field-editor-with-input-mask.component";
import {StringFieldEditorComponent} from "../../../forms/string-field/string-field-editor.component";
import {PhoneNumberInputComponent} from "../../../forms/contact/phone-number-input.component";
import {EmailFieldEditorComponent} from "../../../forms/contact/email-field-editor.component";
import {
    IPsoFamilyAgreementViewModel
} from "../../../../services/booking/models/pso/agreements/families/pso-family-agreement.view-model.interface";
import {DegreeOfKinshipTypeDropDownComponent} from "./components/degree-of-kinship-type-drop-down.component";
import {
    SpecificDegreeOfKinshipTypeFieldEditorComponent
} from "./components/specific-degree-of-kinship-type-field-editor.component";
import {
    FirstToThirdDegreeOfKinshipDescriptionComponent
} from "./components/degree-of-kinship-types/first-to-third-degree-of-kinship-description.component";
import {LegalGuardianDetailsComponent} from "./components/degree-of-kinship-types/legal-guardian-details.component";
import {
    SpecificDegreeOfKinshipFullNameComponent
} from "./components/degree-of-kinship-types/specific-degree-of-kinship-full-name.component";

export const PsoFamilyAgreementComponent: React.FC<{familyAgreement: IPsoFamilyAgreementViewModel;}> = observer((props) => {
    const services = useServices();

    const fields = props.familyAgreement.fields;
    return (
        <FieldsContainerBox>
            <SectionTitleBox>
                {services.language.translate(`Personal details`)}
            </SectionTitleBox>
            <DateFieldEditorWithInputMaskComponent field={fields.dateOfBirth} mask={DateFieldMask.DDMMYYYY} />
            <StringFieldEditorComponent field={fields.birthLocation}/>
            <StringFieldEditorComponent field={fields.residenceLocation}/>
            <StringFieldEditorComponent field={fields.fiscalCode}/>
            <PhoneNumberInputComponent field={fields.phoneNumber} countryField={fields.phoneNumberCountryCode}/>
            <EmailFieldEditorComponent field={fields.email}/>

            <SectionTitleBox>
                {fields.degreeOfKinshipType.fieldName}
            </SectionTitleBox>
            <DegreeOfKinshipTypeDropDownComponent field={fields.degreeOfKinshipType} hideLabel={true}/>
            <FirstToThirdDegreeOfKinshipDescriptionComponent familyAgreement={props.familyAgreement}/>
            <LegalGuardianDetailsComponent familyAgreement={props.familyAgreement}/>

            <SpecificDegreeOfKinshipTypeFieldEditorComponent familyAgreement={props.familyAgreement}/>
            <SpecificDegreeOfKinshipFullNameComponent familyAgreement={props.familyAgreement}/>

            <SectionTitleBox>
                {services.language.translate('Details of the Sardinian Resident')}
            </SectionTitleBox>

            <StringFieldEditorComponent field={fields.residentFullName}/>
            <StringFieldEditorComponent field={fields.residentMunicipality}/>

            <FullGridLineBox>
                <StringFieldEditorComponent field={fields.residentAddress}/>
            </FullGridLineBox>

            <EmailFieldEditorComponent field={fields.residentEmail}/>
            <PhoneNumberInputComponent field={fields.residentPhone} countryField={fields.residentPhoneCountryCode}/>


        </FieldsContainerBox>
    );
})